import { useState } from "react";
import CTAButton from "./CTAButton";
import MediaPreviewModal from "../../MediaPreviewModal";

export default function TestimonialSection({ content = {}, onCheckout, canCheckout }) {
  const title = content.title || "Ribuan Pelanggan Telah Merasakan Manfaatnya";
  const items = content.items || [];
  const [previewMedia, setPreviewMedia] = useState(null);

  return (
    <>
      {previewMedia ? <MediaPreviewModal media={previewMedia} onClose={() => setPreviewMedia(null)} /> : null}
      <section className="py-20 lg:py-28 bg-background">
        <div className="mx-auto max-w-6xl px-5">
          <div className="text-center max-w-2xl mx-auto">
            <span className="text-xs font-bold uppercase tracking-widest text-primary">Testimoni</span>
            <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold text-balance">
              {title}
            </h2>
          </div>

          <div className="mt-12 grid md:grid-cols-3 gap-6">
            {items.map((t, i) => (
              <div
                key={i}
                className="rounded-3xl bg-white border border-border p-7 shadow-card hover:shadow-luxury transition-all duration-300"
              >
                <div className="text-primary text-lg tracking-widest">★★★★★</div>
                {t.image_url ? (
                  <div className="mt-4 overflow-hidden rounded-[1.5rem] border border-border/70 bg-muted/30">
                    <button
                      type="button"
                      onClick={() =>
                        setPreviewMedia({
                          url: t.image_url,
                          title: t.name ? `Lampiran testimoni ${t.name}` : "Lampiran testimoni",
                          type: "image",
                        })
                      }
                      className="block h-full w-full cursor-zoom-in"
                      aria-label={t.name ? `Perbesar lampiran testimoni ${t.name}` : "Perbesar lampiran testimoni"}
                    >
                      <img
                        src={t.image_url}
                        alt={t.name ? `Lampiran testimoni ${t.name}` : "Lampiran testimoni"}
                        className="h-52 w-full object-cover transition duration-300 hover:scale-[1.02]"
                      />
                    </button>
                  </div>
                ) : null}
                <p className="mt-4 text-foreground leading-relaxed italic">"{t.text}"</p>
                <div className="mt-6">
                  <div className="font-semibold text-sm">{t.name}</div>
                  <div className="text-xs text-muted-foreground">{t.role ? `${t.role} • ` : ""}Pembeli Terverifikasi</div>
                  {t.image_url ? <div className="mt-1 text-[11px] font-semibold uppercase tracking-[0.18em] text-primary">Lampiran Testimoni</div> : null}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <CTAButton size="lg" onClick={onCheckout} disabled={!canCheckout}>
              🛒 Pesan Hari Ini
            </CTAButton>
          </div>
        </div>
      </section>
    </>
  );
}
